import script from "./DevNav.vue?vue&type=script&setup=true&lang=js"
export * from "./DevNav.vue?vue&type=script&setup=true&lang=js"

import "./DevNav.vue?vue&type=style&index=0&id=1d078787&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\mfeys\\Desktop\\HAv2\\actions\\19480-florette\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d078787"]])

export default __exports__